import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-sbxwallet-iframe',
  templateUrl: './sbxwallet-iframe.component.html',
  styleUrls: ['./sbxwallet-iframe.component.scss']
})
export class SbxWalletIframeComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Input() url: SafeResourceUrl | string;
  @Input() showLoader = false;
  @Input() headerLogoSrc = 'assets/images/logo-auto-arremate-vertical.svg';
  @Input() allowClose = true;
  @Input() detectCallback?: { urlStartsWith: string };
  @Input() prefillData?: any;

  @Output() close = new EventEmitter<void>();
  @Output() message = new EventEmitter<MessageEvent>();
  @Output() navigatedBack = new EventEmitter<void>();

  @ViewChild('sbxIframe') sbxIframe: ElementRef<HTMLIFrameElement>;

  isReady = false;
  private boundMessage = (event: MessageEvent) => this.onWindowMessage(event);

  ngOnInit(): void {
    window.addEventListener('message', this.boundMessage);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundMessage);
  }

  onIframeLoad(iframe: HTMLIFrameElement): void {
    if (!this.detectCallback?.urlStartsWith) return;
    try {
      const href = iframe.contentWindow!.location.href;
      if (href.startsWith(this.detectCallback.urlStartsWith)) {
        this.navigatedBack.emit();
      }
    } catch {}
  }

  private onWindowMessage(event: MessageEvent): void {
    const superBidOrigin = (() => {
      try { return new URL(environment.superBidUrl).origin; }
      catch { return null; }
    })();

    if (superBidOrigin && event.origin !== superBidOrigin) {
      if (!(event.data && (event.data.source === 'superbid-accounts'))) {
        console.log('not superbid-accounts');
        return;
      }
    }

    if (!event.data || typeof event.data !== 'object') {
      console.log('not object');
      return;
    }

    const { type } = event.data || {};


    if (type === 'IFRAME_READY') {
      this.isReady = true;
      this.sendPrefill();
    }

    if (type === 'FLOW_COMPLETED') {
      this.navigatedBack.emit();
    }

    this.message.emit(event);
  }

  private sendPrefill(): void {
    if (!this.prefillData) {
      console.log('no prefill data');
      return;
    }

    const iframe = this.sbxIframe?.nativeElement;
    if (!iframe || !iframe.contentWindow){
      return;
    }

    const targetOrigin = (() => {
      try { return new URL(environment.superBidUrl).origin; }
      catch { return '*'; }
    })();


    iframe.contentWindow.postMessage({
      type: 'PREFILL_DATA',
      data: this.prefillData
    }, targetOrigin);
  }
}
